import React from 'react';
import ScreenListing from '../components/ScreenListing';
import { getMenuCategoriesOption, getSelectedMenuType } from '../../../../../../../ducks/actions';

export default (props) => {
  const { data } = props;

  return (
    <>
      <ScreenListing
        {...props}
        isKiosk={"1"}
        getMenuCategoriesOption={getMenuCategoriesOption}
      />
    </>
  )
}